import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler, showErrorNotification} from "../../helpers/mainHelpers";
import GeneralInfoTree from "./components/generalTree-list";
import useGeneralInfoController from "../../controllers/generalInfo-controller";
import React, {useEffect} from "react";
import GeneralInfoModal from "./components/generalInfo-modal/GeneralInfoModal";
import AddActionButton from "../../components/action-buttons/addAction-button/AddActionButton";
import {useAuth} from "../../context/authContext";
import ScrollToTopButton from "../../components/main-buttons/scroll-button/ScrollToTopButton";
import "./style.less";

const GeneralInformationPage = () => {
  const generalInfoController = useGeneralInfoController()
  const {canManageContent} = useAuth()
  const {lastUpdate, fetchGeneralInfoItemsList, isModalOpen} = generalInfoController
  useEffect(() => {
    fetchGeneralInfoItemsList([])
  }, [lastUpdate])

  // const headerActions = <>
  //   {canManageContent && <AddActionButton onClick={toggleModal}/>}
  // </>

  const headerActions = <>
    {canManageContent && <AddActionButton onClick={()=>{
      showErrorNotification({
        message: "Створення в процесі розробки!",
      })
    }
    }/>}
  </>




  return (
    <>
      <div className="page_title">
        <PageHeader
          title={
            <div className="page-header_title">
              <div className="page_name">
                Інформація для громадян
              </div>
            </div>
          }
          extra={headerActions}
          onBack={navigateBackHandler}
        />
      </div>
      <div className="page_content general-information-page">
        <GeneralInfoTree generalInfoController={generalInfoController}/>
        <ScrollToTopButton elementSelector={".page_content"}/>
      </div>
      {isModalOpen && <GeneralInfoModal generalInfoController={generalInfoController}/>}

    </>)
}

export default GeneralInformationPage
